import { FETCH_PRODUCTS, FETCH_PRODUCTS_FAIL, FETCH_CYOA_PRODUCTS, FETCH_CYOA_PRODUCTS_FAIL, SAVE_PRODUCT } from '../actions/types';
import update from 'immutability-helper';

export function FetchProducts(state ={}, action){
  switch (action.type) {
    case FETCH_PRODUCTS:
      return action.payload.data.data;
    case FETCH_PRODUCTS_FAIL:
    default:
      return state;
  }
}

export function FetchCyoaProducts(state ={}, action){
  switch (action.type) {
    case FETCH_CYOA_PRODUCTS:
      return action.payload.data;
    case FETCH_CYOA_PRODUCTS_FAIL:
    default:
      return state;
  }
}


const productInitalState = {
  redirect:false,
  header:{},
  map:[],
  content:{}
}

export function SaveProduct(state = productInitalState, action){
  switch (action.type) {
    case SAVE_PRODUCT :
      return update(state, {
        header: {$set:JSON.parse(action.payload).header},
        map: {$set:JSON.parse(action.payload).map},
        content: {$set:JSON.parse(action.payload).content},
        redirect:{$set:false}
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_product.js